import { Component, OnInit, ElementRef, ViewChild, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { CuentaCorrienteService, DeudaGradoModel } from 'src/app/services/cuentacorriente.service';
import { GradoService } from 'src/app/services/grado.service';
import { ConstService } from 'src/app/services/const.service';
import { Grado } from 'src/app/models/grado.model';
import { take } from 'rxjs/operators';
import { MesAnioSelected } from 'src/models/data';

Chart.register(...registerables);



@Component({
  selector: 'app-deuda-por-grado',
  templateUrl: './deuda-por-grado.component.html',
  styleUrls: ['./deuda-por-grado.component.css']
})
export class DeudaPorGradoComponent implements OnInit, OnDestroy {
  @ViewChild('deudasChart') private chartCanvas!: ElementRef<HTMLCanvasElement>;
  
  public chart: Chart | undefined;
  public cargando: boolean = false;
  public sinDatos: boolean = false;

  // Filtros
  public mesSeleccionado: number = new Date().getMonth() + 1;
  public anioSeleccionado: number = new Date().getFullYear();
  public gradoSeleccionado: number = 0;

  public grados: Grado[] = [];

  // Datos
  private todosLosDatosDeuda: DeudaGradoModel[] = [];

  constructor(
    private cuentaCorrienteService: CuentaCorrienteService,
    private gradosService: GradoService,
    private constService: ConstService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.cargarGrados();
    //this.consultarDeuda();
  }

  private cargarGrados(): void {
    this.gradosService.getGradosPorEscuelaNoPaging()
      .pipe(take(1))
      .subscribe({
        next: (resp: any) => {
          if (resp && resp.resultList) {
            this.grados = resp.resultList;
          } else if (Array.isArray(resp)) {
            this.grados = resp;
          }
          this.cdr.detectChanges();
        },
        error: (err) => {
          console.error('Error al cargar grados:', err);
        }
      });
  }

  public onPeriodoSeleccionado(periodo: MesAnioSelected): void {
    if (periodo) {
      this.consultarDeuda(periodo);
    }
  }

  public consultarDeuda(periodo: MesAnioSelected): void {
    this.cargando = true;
    this.sinDatos = false;
    this.cdr.detectChanges();

    this.cuentaCorrienteService.obtenerDeudaPorGrados(periodo.mesdesde, periodo.aniodesde, periodo.meshasta, periodo.aniohasta, this.gradoSeleccionado)
      .pipe(take(1))
      .subscribe({
        next: (resp: any) => {
          this.cargando = false;
          if (resp && resp.ok && resp.datosDeuda) {
            this.todosLosDatosDeuda = resp.datosDeuda;
          } else if (Array.isArray(resp)) {
            this.todosLosDatosDeuda = resp;
          } else {
            this.todosLosDatosDeuda = [];
          }
          this.aplicarFiltroGrado();
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.cargando = false;
          console.error('Error al consultar deudas por grado:', err);
          this.todosLosDatosDeuda = [];
          this.aplicarFiltroGrado();
          this.cdr.detectChanges();
        }
      });
  }

  public aplicarFiltroGrado(): void {
    let datosFiltrados = [...this.todosLosDatosDeuda];

    // if (this.gradoSeleccionado !== 'TODOS') {
    //   datosFiltrados = datosFiltrados.filter(item => item.grado === this.gradoSeleccionado);
    // }

    this.sinDatos = datosFiltrados.length === 0;
    this.cdr.detectChanges();

    setTimeout(() => {
      if (this.chartCanvas && !this.sinDatos) {
        this.generarGraficoBarra(datosFiltrados);
      } else if (this.chart) {
        this.chart.destroy();
        this.chart = undefined;
      }
    }, 0);
  }

  generarGraficoBarra(datos: DeudaGradoModel[]): void {
    if (this.chart) {
      this.chart.destroy();
    }

    const labels = datos.map(item => item.grado);
    const dataMesActual = datos.map(item => item.deudaMesActual);
    const dataAnioAnterior = datos.map(item => item.deudaMesAnioAnterior);

    const canvasCtx = this.chartCanvas.nativeElement.getContext('2d');
    if (!canvasCtx) return;

    const nombreMes = `Mes ${this.mesSeleccionado}`;
    const anioActual = this.anioSeleccionado;
    const anioAnterior = Number(this.anioSeleccionado) - 1;

    this.chart = new Chart(canvasCtx, {
      type: 'bar',
      data: {
        labels: labels,
        datasets: [
          {
            label: `Deuda ${nombreMes} ${anioActual}`,
            data: dataMesActual,
            backgroundColor: 'rgba(54, 162, 235, 0.75)',
            borderColor: 'rgba(54, 162, 235, 1)',
            borderWidth: 1.5,
            borderRadius: 4
          },
          {
            label: `Deuda ${nombreMes} ${anioAnterior}`,
            data: dataAnioAnterior,
            backgroundColor: 'rgba(255, 99, 132, 0.75)',
            borderColor: 'rgba(255, 99, 132, 1)',
            borderWidth: 1.5,
            borderRadius: 4
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
            text: `Comparativo de Deuda por Grado - ${nombreMes} (${anioActual} vs ${anioAnterior})`,
            font: { size: 16, weight: 'bold' }
          },
          tooltip: {
            callbacks: {
              label: (context) => {
                const valor = context.raw as number;
                return `${context.dataset.label}: ${new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS' }).format(valor)}`;
              }
            }
          },
          legend: {
            position: 'top'
          }
        },
        scales: {
          x: {
            stacked: true
          },
          y: {
            stacked: true,
            beginAtZero: true,
            ticks: {
              callback: (value) => {
                return new Intl.NumberFormat('es-AR', { style: 'currency', currency: 'ARS', maximumFractionDigits: 0 }).format(Number(value));
              }
            }
          }
        }
      }
    });
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }
}

